export default __webpack_public_path__ + "static/media/dpr.ab245bde.svg";